module.exports = __webpack_public_path__ + "img/product-detail-marketing-promo-bg-mobile.550b1a0.jpg";